// Site-wide constants and helpers
// Public booking page (Book.jsx, customer-facing) sees only SLOT_TIMES.
// The 16:00 slot is admin-only — see ADMIN_SLOT_TIMES below.
export const SLOT_TIMES = ["08:00", "10:45", "13:30"];
export const ADMIN_SLOT_TIMES = ["08:00", "10:45", "13:30", "16:00"];

export const TRANSMISSION_BY_WEEKDAY = {
  // JS getDay(): Sun=0, Mon=1, ... Sat=6
  1: "manual",
  2: "manual",
  3: "manual",
  4: "manual",
  5: "auto",
  6: "manual",
  0: null,
};

export const PRODUCTS = {
  standard: { label: "Standard 2-Hour Lesson", slots: 1, hours: 2 },
  package10: { label: "10-Hour Package", slots: 5, hours: 10 },
  package20: { label: "20-Hour Package", slots: 10, hours: 20 },
  bespoke: { label: "Bespoke Package", slots: 0, hours: 0 },
};

export function endTime(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  const total = h * 60 + m + 120;
  const h2 = Math.floor(total / 60);
  const m2 = total % 60;
  return `${String(h2).padStart(2, "0")}:${String(m2).padStart(2, "0")}`;
}

export function formatGBP(n) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);
}

export function formatDate(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
}

export function formatLongDate(dateStr) {
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
}
